import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3105/all/category";
};

export const loadBusinessCategory = params => {
  const url = `${baseURL()}/loadLololCategory`;

  return axios.post(url, params);
};
